"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EConfigEditaCampoRematricula = exports.EDeltaClassIntegracao = exports.EPaginaInicialOnlineResponsavel = exports.EPaginaInicialOnlineAluno = exports.EMarcaLoginPadrao = void 0;
var EMarcaLoginPadrao;
(function (EMarcaLoginPadrao) {
    EMarcaLoginPadrao["Aluno"] = "aluno";
    EMarcaLoginPadrao["Respons\u00E1vel"] = "responsavel";
    EMarcaLoginPadrao["Professor"] = "professor";
})(EMarcaLoginPadrao = exports.EMarcaLoginPadrao || (exports.EMarcaLoginPadrao = {}));
var EPaginaInicialOnlineAluno;
(function (EPaginaInicialOnlineAluno) {
    EPaginaInicialOnlineAluno["Avisos"] = "avisos";
    EPaginaInicialOnlineAluno["Biblioteca"] = "biblioteca";
    EPaginaInicialOnlineAluno["Boletim"] = "boletim";
    EPaginaInicialOnlineAluno["Provas"] = "calendario";
    EPaginaInicialOnlineAluno["Conte\u00FAdo Ministrado"] = "conteudo_ministrado";
    EPaginaInicialOnlineAluno["Hor\u00E1rios"] = "horarios";
    EPaginaInicialOnlineAluno["Materiais"] = "materiais";
    EPaginaInicialOnlineAluno["Ocorr\u00EAncias"] = "ocorrencias";
    EPaginaInicialOnlineAluno["Perfil do Aluno"] = "perfil";
})(EPaginaInicialOnlineAluno = exports.EPaginaInicialOnlineAluno || (exports.EPaginaInicialOnlineAluno = {}));
var EPaginaInicialOnlineResponsavel;
(function (EPaginaInicialOnlineResponsavel) {
    EPaginaInicialOnlineResponsavel["Avisos"] = "avisos";
    EPaginaInicialOnlineResponsavel["Biblioteca"] = "biblioteca";
    EPaginaInicialOnlineResponsavel["Boletim"] = "boletim";
    EPaginaInicialOnlineResponsavel["Provas"] = "calendario";
    EPaginaInicialOnlineResponsavel["Conte\u00FAdo Ministrado"] = "conteudo_ministrado";
    EPaginaInicialOnlineResponsavel["Ficha de Sa\u00FAde"] = "fichasaude";
    EPaginaInicialOnlineResponsavel["Financeiro"] = "financeiro";
    EPaginaInicialOnlineResponsavel["Hor\u00E1rios"] = "horarios";
    EPaginaInicialOnlineResponsavel["Log da Catraca"] = "catraca";
    EPaginaInicialOnlineResponsavel["Materiais"] = "materiais";
    EPaginaInicialOnlineResponsavel["Ocorr\u00EAncias"] = "ocorrencias";
    EPaginaInicialOnlineResponsavel["Documentos"] = "documentos";
    EPaginaInicialOnlineResponsavel["Documentos N\u00E3o Entregues"] = "docnentregue";
    EPaginaInicialOnlineResponsavel["Pessoas autorizadas"] = "autorizacao_transporte";
    EPaginaInicialOnlineResponsavel["Perfil do Aluno"] = "perfil";
})(EPaginaInicialOnlineResponsavel = exports.EPaginaInicialOnlineResponsavel || (exports.EPaginaInicialOnlineResponsavel = {}));
var EDeltaClassIntegracao;
(function (EDeltaClassIntegracao) {
    EDeltaClassIntegracao["IsCool"] = "iscool";
})(EDeltaClassIntegracao = exports.EDeltaClassIntegracao || (exports.EDeltaClassIntegracao = {}));
var EConfigEditaCampoRematricula;
(function (EConfigEditaCampoRematricula) {
    EConfigEditaCampoRematricula["N\u00E3o"] = "0";
    EConfigEditaCampoRematricula["Sim"] = "1";
    EConfigEditaCampoRematricula["Se vazio"] = "sevazio";
})(EConfigEditaCampoRematricula = exports.EConfigEditaCampoRematricula || (exports.EConfigEditaCampoRematricula = {}));
